import type {
  FieldConfig,
  SectionConfig,
} from '@/components/form/SchemaForm/types';
import type { DefaultOptionType } from 'antd/es/select';
import type { TFunction } from 'i18next';

type UserPreferenceFieldsOptions = {
  t: TFunction;
  languageOptions: DefaultOptionType[];
  currencyRequired?: boolean;
  languageRequired?: boolean;
  /** Form field names — defaults match client invitation (`currency` / `language`). */
  currencyFieldName?: string;
  languageFieldName?: string;
};

function buildUserPreferenceFieldConfigs(
  options: UserPreferenceFieldsOptions,
): FieldConfig[] {
  const {
    t,
    languageOptions,
    currencyFieldName = 'currency',
    languageFieldName = 'language',
  } = options;

  return [
    {
      name: currencyFieldName,
      type: 'currency',
      colSpan: 12,
      label: t('DEFAULT_CURRENCY'),
    },
    {
      name: languageFieldName,
      type: 'select',
      colSpan: 12,
      label: t('DEFAULT_LANGUAGE'),
      componentProps: {
        options: languageOptions,
      },
    },
  ];
}

export function buildUserPreferenceSection(
  options: UserPreferenceFieldsOptions,
): SectionConfig {
  return {
    key: 'preferences',
    fields: buildUserPreferenceFieldConfigs(options),
  };
}
